module.exports = __webpack_public_path__ + "img/Vision_01.1e886eb4.jpg";